<script setup lang="ts">
import { computed } from 'vue';
import type { UiIconProps } from './types';
import sprite from './ui-icons.svg';

const {
  variant,
  resetSize,
} = defineProps<UiIconProps>();

const baseClasses = 'inline-flex items-center justify-center h-4 w-4 fill-current stroke-current text-current';

const variantClass = computed(() => {
  switch (variant) {
    case 'primary':
      return 'stroke-blue-600';
    case 'neutral':
      return 'stroke-gray-500';
    default:
      return '';
  }
});

const sizeClass = computed(() => resetSize ? 'w-auto h-auto' : '');
</script>

<template>
  <svg
    :key="name"
    :class="[baseClasses, variantClass, sizeClass, svgClass]"
  >
    <use :href="`${sprite}#${name}`" />
  </svg>
</template>
